/* eslint-disable max-len */
import * as React from 'react';
import { ScrollToTopButton, ScrollToTopOnMount } from '../scrolltotop';
import { OpenCloseContainer } from '../containers';
import { FAQS } from '../../lib/faqs';

export const Faqs = () => {
  const numItemsHalf =  Math.ceil(FAQS.length / 2);
  return(
    <>
      <ScrollToTopOnMount />
      <div className='content_page'>
        <h1>Veelgestelde vragen</h1>
        <div className='text_block faq'>
          <div>
            {FAQS.slice(0, numItemsHalf).map((item, index) => <OpenCloseContainer key={index} label={item.label} content={item.content}/>)}
          </div>
          <div>
            {FAQS.slice(numItemsHalf, FAQS.length).map((item, index) => <OpenCloseContainer key={index} label={item.label} content={item.content}/>)}
          </div>
        </div>
      </div>
      <ScrollToTopButton />
    </>
  ); 
};
